import type { OnChangeValue, Option } from '@ksyos/design-system';
import { Select } from '@ksyos/design-system';
import type { AccountDeactivationPractitioner } from '@common/interfaces/api/accountDeactivationApi';
import { getDisplayName } from '@common/utils/getDisplayName';
import { getValidationErrorTranslation } from '@frontend/utils';
import type { ValidationErrors } from '../../../utils/validation';
import type { IPractitioner } from '../../interfaces/practitioner';

interface SelectPractitionerProps {
    errors: ValidationErrors;
    onChange: (practitionerId: string) => void;
    practitioners: AccountDeactivationPractitioner[];
}

export function SelectPractitioner(props: Readonly<SelectPractitionerProps>) {
    const practitioners: Option[] = getPractitionerOptions();

    return (
        <Select
            error={getValidationErrorTranslation(props.errors.get('practitionerId')) ?? undefined}
            onChange={handleChange}
            options={practitioners}
            placeholder={''}
        />
    );
    function handleChange(newValue: OnChangeValue<Option, false>) {
        props.onChange(newValue!.value);
    }

    function getPractitionerOptions(): Option[] {
        const options = props.practitioners.map((practitioner: IPractitioner) => ({
            label: getDisplayName(practitioner),
            value: practitioner.id,
        })) as Option[];

        return options;
    }
}
